import { useEffect, useState } from 'react'
import supabase from '../../../lib/supabase'
import { Actions, Area, Row, Select, Text, TwoColumn, clean } from './EditorFields'

const blank = { name: '', location_type: 'establishment', branch_code: '', address: '', city: '', postal_code: '', phone: '', email: '', maps_url: '', is_primary: false, status: 'active', notes: '' }

export default function ClientLocationsEditor({ client, onChanged }) {
  const [rows, setRows] = useState([])
  const [form, setForm] = useState(blank)
  const [id, setId] = useState(null)
  const [saving, setSaving] = useState(false)
  const set = (key, value) => setForm((current) => ({ ...current, [key]: value }))

  useEffect(() => { load() }, [client.id])
  async function load() { const { data, error } = await supabase.from('codevaro_client_locations').select('*').eq('client_id', client.id).order('name'); if (error) return alert(error.message); setRows(data || []) }
  function edit(row) { setId(row.id); setForm({ ...blank, ...row }) }
  function reset() { setId(null); setForm(blank) }
  async function save(event) {
    event.preventDefault(); if (!form.name.trim()) return
    setSaving(true)
    const payload = clean({ ...form, client_id: client.id })
    const result = id ? await supabase.from('codevaro_client_locations').update(payload).eq('id', id) : await supabase.from('codevaro_client_locations').insert(payload)
    setSaving(false); if (result.error) return alert(result.error.message)
    reset(); await load(); if (onChanged) await onChanged()
  }

  return <TwoColumn title="Locations / establishments" rows={rows} renderRow={(row) => <Row key={row.id} title={row.name} subtitle={[row.location_type,row.city,row.branch_code].filter(Boolean).join(' · ')} onEdit={() => edit(row)} />}>
    <form onSubmit={save} className="grid grid-cols-1 gap-3 md:grid-cols-2">
      <Text label="Name *" value={form.name} onChange={(v) => set('name', v)} />
      <Select label="Type" value={form.location_type} onChange={(v) => set('location_type', v)}><option value="establishment">Establishment</option><option value="office">Office</option><option value="warehouse">Warehouse</option><option value="home">Home</option><option value="other">Other</option></Select>
      <Text label="Branch code" value={form.branch_code} onChange={(v) => set('branch_code', v)} />
      <Text label="Phone" value={form.phone} onChange={(v) => set('phone', v)} />
      <Text label="Address" value={form.address} onChange={(v) => set('address', v)} />
      <Text label="City" value={form.city} onChange={(v) => set('city', v)} />
      <Text label="Postal code" value={form.postal_code} onChange={(v) => set('postal_code', v)} />
      <Text label="Email" value={form.email} onChange={(v) => set('email', v)} />
      <Text label="Google Maps URL" value={form.maps_url} onChange={(v) => set('maps_url', v)} />
      <Select label="Status" value={form.status} onChange={(v) => set('status', v)}><option>active</option><option>inactive</option></Select>
      <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={!!form.is_primary} onChange={(e) => set('is_primary', e.target.checked)} /> Primary location</label>
      <div className="md:col-span-2"><Area label="Notes" value={form.notes} onChange={(v) => set('notes', v)} /></div>
      <Actions saving={saving} editing={!!id} reset={reset} />
    </form>
  </TwoColumn>
}